import { type ComponentProps, memo, type NamedExoticComponent } from "react";
import { Streamdown } from "streamdown";

import { cn } from "@src/lib/utils";

type ResponseProps = ComponentProps<typeof Streamdown>;

export const Response: NamedExoticComponent<ResponseProps> = memo(
  ({ className, ...props }: ResponseProps) => (
    <Streamdown
      className={cn(
        "ai-chat-text size-full [&>*:first-child]:mt-0 [&>*:last-child]:mb-0",
        className
      )}
      {...props}
    />
  ),
  (prevProps, nextProps) => prevProps.children === nextProps.children
);

Response.displayName = "Response";
